// Global UI component initializations shared across all portals.

// Auto-dismiss non-static alerts after 6 seconds
document.addEventListener("DOMContentLoaded", function () {
  window.setTimeout(function () {
    (window.$ || $)(
      ".alert:not([data-static='static']):not([data-dismiss='alert'])",
    )
      .fadeTo(500, 0)
      .slideUp(500, function () {
        (window.$ || $)(this).alert("close");
      });
  }, 6000);
});

// Disable blank first option on selects
document.addEventListener("DOMContentLoaded", function () {
  $(".select-disable-blank").find("option:eq(0)").prop("disabled", true);
});

// Bootstrap popovers (use window.$ — Sprockets' jQuery with Bootstrap plugins)
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    if (window.$ && window.$.fn.popover) {
      window.$('[data-toggle="popover"]').popover();
    }
  }, 5000);
});

// Bootstrap tooltips
document.addEventListener("DOMContentLoaded", function () {
  if (window.$ && window.$.fn.tooltip) {
    window.$('[data-toggle="tooltip"]').tooltip();
  }
});
